const path = window.location.pathname || "";

export const API_BASE = path.includes("/finaloutput/public_html")
  ? "/api"
  : "/api";
